import { FC, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router";

interface Props {}

/**========================================================================
 *                          external const here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

/**========================================================================
 *                           external methods here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

export const LandingPage: FC<Props> = () => {
  /**========================================================================
   *                           Hooks here
   *========================================================================**/
  const { user, isAccountant, isTreasury } = useAuth();
  let navigate = useNavigate();
  useEffect(() => {
    if (user) {
      if (isTreasury) {
        return navigate("/cash-management");
      }
      if (isAccountant) {
        return navigate("/cash-balance");
      }
      return navigate("/draw-requests");
    }
  }, [user]);

  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Const here
   *========================================================================**/

  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Methods here
   *========================================================================**/

  /*============================ END OF SECTION ============================*/

  return (
    <>
      {/* /========================================================================  HTML here
    ========================================================================*/}
      {/*============================ END OF SECTION ============================*/}
    </>
  );
};
